import { useMemo } from 'react';
import { useLocalStorageModals } from './useLocalStorageModals';

export const useCustomizationInfoModals = () => {
  const modalsPull = useMemo(() => {
    return [...[]];
  }, []);

  useLocalStorageModals(modalsPull);
};
